import React from "react";
import { Button, Card, Col, Row, Space, Tag, Typography } from "antd";
import {
  ApartmentOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminValidation from "../../../components/adminvalidation/AdminValidation";
import styles from "./AdminOverview.module.scss";

const { Title, Paragraph, Text } = Typography;

const AdminOverview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AdminValidation>
      <div className={styles.wrapper}>
        <Card className={styles.hero} bordered={false}>
          <Space direction="vertical" size={8}>
            <Tag color="blue" icon={<SafetyCertificateOutlined />}>
              {t("AdminOverview-AdminOrganization")}
            </Tag>
            <Title level={2} className={styles.title}>
              {t("AdminOverview-Title")}
            </Title>
            <Paragraph className={styles.subtitle}>
              {t("AdminOverview-Description")}
            </Paragraph>
          </Space>
        </Card>

        <Card className={styles.contextCard}>
          <Title level={4}>{t("AdminOverview-NoOrganizationTitle")}</Title>
          <Paragraph>{t("AdminOverview-NoOrganizationDescription")}</Paragraph>
          <Text type="secondary">{t("AdminOverview-SelectorHint")}</Text>
        </Card>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card className={styles.actionCard}>
              <ApartmentOutlined className={styles.actionIcon} />
              <Title level={4}>{t("AdminOverview-OrganizationsTitle")}</Title>
              <Paragraph>
                {t("AdminOverview-OrganizationsDescription")}
              </Paragraph>
              <Button
                type="primary"
                onClick={() => navigate("/admin/organizations")}
              >
                {t("AdminOverview-OrganizationsAction")}
              </Button>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card className={styles.actionCard}>
              <TeamOutlined className={styles.actionIcon} />
              <Title level={4}>{t("AdminOverview-UsersTitle")}</Title>
              <Paragraph>{t("AdminOverview-UsersDescription")}</Paragraph>
              <Button onClick={() => navigate("/admin/users")}>
                {t("AdminOverview-UsersAction")}
              </Button>
            </Card>
          </Col>
        </Row>
      </div>
    </AdminValidation>
  );
};

export default AdminOverview;
